import { FC } from "react";
import { IconButton, Stack } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ResourceExplorerActionsMenu } from "./ResourceExplorerActionsMenu";
import { navItemSecondaryActionButtonVisibilityStyles } from "../../../../../../utils/helpers/navItemSecondaryActionButtonVisibilityStyles";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";
import { useAppSelector } from "@/store/hooks";
import { NavigationItemsVisibilityType } from "@/store/navigation/utils/types";
import { resourceExplorerHierarchyVisibilityIsDefaultSelector } from "@/store/resource-explorer/selectors/views-hierarchy-visibility/resourceExplorerHierarchyVisibilityIsDefaultSelector";
import { EmbeddedUser, ProtectionDetails } from "@/services/cloudchipr.api";

interface BillingExplorerActionButtonProps {
  id: string;
  name: string;
  folderId?: string;
  size?: "small" | "medium" | "large";
  visibility: NavigationItemsVisibilityType;
  protectedBy?: EmbeddedUser;
  protectionDetails?: ProtectionDetails;
}

export const BillingExplorerActionButton: FC<
  BillingExplorerActionButtonProps
> = ({
  id,
  name,
  folderId,
  visibility,
  size,
  protectionDetails,
  protectedBy,
}) => {
  const isVisibilityItemDefault = useAppSelector((state) =>
    resourceExplorerHierarchyVisibilityIsDefaultSelector(state, id),
  );

  const { anchor, open, openMenu, closeMenu } = useMenuHook();

  if (isVisibilityItemDefault) {
    return null;
  }

  return (
    <Stack direction="row" justifyContent="flex-end">
      <IconButton
        size="small"
        onClick={openMenu}
        sx={navItemSecondaryActionButtonVisibilityStyles(open)}
      >
        <MoreVertIcon fontSize={size ?? "inherit"} />
      </IconButton>

      <ResourceExplorerActionsMenu
        id={id}
        name={name}
        open={open}
        anchor={anchor}
        closeMenu={closeMenu}
        folderId={folderId}
        visibility={visibility}
        protectedBy={protectedBy}
        protectionDetails={protectionDetails}
      />
    </Stack>
  );
};
